import React from 'react'

import Select from 'react-select'
import axios from 'axios'
import {getToken} from '../../../storage'
import {API_BASE_URL} from '../../../constants'

import {AddBatchModal} from '../../modal/modal'

class BatchExtended extends React.Component {

  render() {

    const option = this.props.option
    const name = option.name
    var stock = option.closing_stock

    if(typeof option.className !== "undefined" && option.className !== null) {
      return name
    }
    else {
      let suffix
      if (parseFloat(stock) <= 0) {
        suffix = "Out of stock"
      }
      else {
        const unit = this.props.item.unit
        if(typeof unit !== "undefined" && unit !== null) {
          if(typeof unit.container_unit !== "undefined" && unit.container_unit !== null && unit.container_unit.length > 0) {
            const containers = parseInt(parseFloat(stock)/parseFloat(unit.container_volume), 10)
            const remaining_primary_units = stock - (containers * unit.container_volume)
            suffix = containers +" " + unit.container_unit + " " + remaining_primary_units + " "+unit.primary_unit
          }
          else {
            suffix =  Number(stock)+" "+ unit.primary_unit
          }
        }
        else {
          suffix = ""
        }
      }
      return name + "-" + suffix
    }
  }
}


export default class BatchElement extends React.Component {

  constructor(props){
    super(props)
    this.handleChange = this.handleChange.bind(this)
    this.renderOption = this.renderOption.bind(this)
    this.createBatchPromt = this.createBatchPromt.bind(this)
    this.state= {showItemCreate:false}
    this.getBatches = this.getBatches.bind(this)
  }


  createBatchPromt(input){
    return "Create new batch ?"
  }


  handleChange(batch){
    if(batch !== null && typeof batch.className !== "undefined") {
      this.setState({showBatchCreate:true})

    }
    else if(batch !== null) {
      let item = this.props.item
      item['batch'] = batch
      this.props.onChangeCallback(item)
      this.setState({showBatchCreate:false})
    }
  }

  getBatches (input) {
    let item = this.props.item, item_id
    if(typeof item === "undefined" || item === null) {
      return Promise.resolve({ options: [] });
    }

    item_id = item.item
    if(typeof item_id === "undefined" || item_id === null) {
      return Promise.resolve({ options: [] });
    }
    if(typeof item.item === "object") {
      item_id = item.item.id
    }

    return   axios({
        url: '/list_batches/?item_id='+item_id,
        method: 'get',
        baseURL: API_BASE_URL,
        headers: {
          common: {
            'Authorization': 'Token ' + getToken()
          }
        }
      }).then((response)=> {
            return {options: response.data.batchs}
      }).catch((err)=> {

        return Promise.resolve({ options: [] });
      })
}

renderOption(option) {
  return <BatchExtended option={option} item={this.props.item} />
}

  render() {


    let modal = <AddBatchModal show={this.state.showBatchCreate} onAddCallback={this.handleChange} />


    let  item = this.props.item, inputValue
    if(typeof item !== "undefined" && item !== null) {
      inputValue = item.batch
    }

    return (<div>
        {modal}
    <Select.AsyncCreatable name="name" className="" value={inputValue}
        optionRenderer={this.renderOption}
      valueKey="id" labelKey="name" loadOptions={this.getBatches} onChange={this.handleChange} />
    </div>)


  }
}



// WEBPACK FOOTER //
// ./src/components/purchase/rowelements/batchelement.js